
import ReactPixel from 'react-facebook-pixel';

export const trackEvent = (pixelId: string, eventName: string, data = {}) => {
    ReactPixel.trackCustom(eventName, { pixelId, ...data });
};
